<template >
  <splash></splash>
  <div class="container mt-4" dir="rtl">

  <sidebar></sidebar>
    <div style="    position: absolute;
    right: 28vw;
    width: 51vw; height: auto;" class="card-panel-main col-lg-9 mb-5">
      <div class="card card-body card-panel-box border-0" style="    margin: 1vw .9vw;">
        <center>
          <p style="font-size: 2vw"> ماتریس ارتباطات </p>
          <hr>
          <br>
        </center>

         <div class="d-flex flex-nowrap ">
           <div class="card p-4 w-50">
             <center>
               <p style="font-weight: bold; font-size: 1.3vw;">ماتریس ارتباطات درونی  </p>
               <br>
               <router-link class="btn btn-submit-1 btn-info w-50" to="/Matrix_Connections/include">تکمیل اطلاعات / بروزرسانی</router-link>
             </center>
           </div>
           <div class="card p-4 w-50 mx-2">
             <center>
               <p style="font-weight: bold; font-size: 1.3vw;">ماتریس ارتباطات بیرونی  </p>
               <br>
               <router-link class="btn btn-submit-1 btn-info w-50" to="/Matrix_Connections/exit">تکمیل اطلاعات / بروزرسانی</router-link>
             </center>
           </div>
         </div>
        <br>




      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import Sidebar from "@/components/Sidebar/Sidebar";
import splash from "@/components/Splash/Splash";
import router from "@/router";

export default {
  name: 'HomeView',
  components: {
    Sidebar,
    splash
  },
  methods:{
    checkIsMother(){
      if (this.is_mother){
        router.push('/mother_items')
        return
      }

    }
  },
  mounted() {
    this.checkIsMother()
  }
}
</script>
